// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemsOverviewPage_container__F2bSm","header":"ItemsOverviewPage_header__1tz4b","noResults":"ItemsOverviewPage_noResults__1zW0f"};